import { type FC } from 'react';

import { BaseIcon, type BaseIconOuterProps } from '@/components/common/icons/BaseIcon';

export const CheckIcon: FC<BaseIconOuterProps> = (props) => {
  return (
    <BaseIcon iconType="stroke" {...props}>
      <path d="M5 12L10 17L20 7" />
    </BaseIcon>
  );
};
